<template>
    <div class="main" v-loading.fullscreen="isLoad" router element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb class="bnone">
            <el-breadcrumb-item>系统设置</el-breadcrumb-item>
            <el-breadcrumb-item>支付配置</el-breadcrumb-item>
        </el-breadcrumb>
        <el-tabs v-model="currentTab">
            <el-tab-pane :label="ele.label" :name="ele.pay_type" v-for="(ele, index) in headerList" :key="index">
                <template v-if="ele.value == 'weixin'">
                    <el-form ref="form" label-position="right" :model="item" label-width="auto" show-message
                             inline-message
                             status-icon>
                        <el-divider content-position="left">微信支付 V2 版本</el-divider>
                        <el-form-item label="Mchid">
                            <el-input v-model="item.wx_mchid"></el-input>
                        </el-form-item>
                        <el-form-item label="V2密钥">
                            <el-input v-model="item.wx_key_v2"></el-input>
                        </el-form-item>
                        <el-form-item label="商户证书(apiclient_cert.pem)">
                            <el-input
                                    type="textarea"
                                    :rows="2"
                                    placeholder="请输入商户证书"
                                    v-model="item.wx_ssl_cert">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="商户私钥(apiclient_key.pem)">
                            <el-input
                                    type="textarea"
                                    :rows="2"
                                    placeholder="请输入商户私钥"
                                    v-model="item.wx_ssl_key">
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submit" v-auth="['store/seller/paymentEdit']">保存
                            </el-button>
                        </el-form-item>
                    </el-form>
                </template>
                <template v-if="ele.value == 'allinpay'">
                    <el-form ref="form" label-position="right" :model="formItem" label-width="auto" show-message
                             inline-message
                             status-icon>
                        <el-form-item label="支付应用Appid">
                            <el-input v-model="formItem.allinpay.appid" placeholder=""></el-input>
                            <div class="info-wrapper">支付应用Appid</div>
                        </el-form-item>
                        <el-form-item label="支付应用Appid">
                            <el-input v-model="formItem.allinpay.mchtId" placeholder=""></el-input>
                            <div class="info-wrapper">支付应用商户号</div>
                        </el-form-item>
                        <el-form-item label="支付密钥文件">
                            <el-input style="width: 300px" type="text" v-model="formItem.allinpay.key_file" placeholder=""></el-input>
                            <uploadfile :type="'pfx'" :format="['pfx']" @uploadSuccess="uploadSuccess"></uploadfile>
                        </el-form-item>
                        <el-form-item label="支付密码">
                            <el-input type="text" v-model="formItem.allinpay.password"
                                      placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="">
                            <el-button type="primary" @click="submit1">保存</el-button>
                        </el-form-item>
                    </el-form>

                </template>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    import uploadfile from '@/components/uploadfile/index';

    export default {
        components: {
            uploadfile
        },
        data() {
            return {
                item: {},
                isLoad: false,
                currentTab: '20',
                headerList: [
                    {
                        label: '微信支付',
                        pay_type: '20',
                        value: 'weixin'
                    },
                    {
                        label: '通联支付',
                        pay_type: '50',
                        value: 'allinpay',
                    },
                ],
                formItem: {
                    allinpay: {
                        open: false,
                        appid: '',
                        mchid: '',
                        public_key: '',
                        private_key: '',
                    },
                }
            }
        },
        created() {
            this.loadItem()
            this.getDetail()
        },
        methods: {
            getDetail() {
                this.axios.post('/store/setting/detail', {
                    'key': 'payment',
                })
                .then(async (res) => {
                    this.loading = false;
                    if (res.code == 1 && res.data.values) {
                        this.formItem = res.data.values
                    } else {
                        this.loading = false;
                        this.$message.error(res.msg);
                    }
                })
            },
            uploadSuccess: function (res) {
                this.formItem.allinpay.key_file = res.external_url
            },
            submit1() {
                if (this.isLoad)
                    return
                this.axios.post('/store/setting/update', {
                    'key': 'payment',
                    form: this.formItem,
                })
                    .then(async (res) => {
                        if (res.code == 1) {
                            this.loading = false;
                            this.$message.success(res.msg);
                        } else {
                            this.loading = false;
                            this.$message.error(res.msg);
                        }
                    })
                    .catch((res) => {
                        this.loading = false;
                    });
            },
            loadItem() {
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.get('/store/setting/payment').then(res => {
                    this.isLoad = !this.isLoad
                    if (res.data.detail) {
                        this.item = res.data.detail
                    }
                }).catch(() => {
                    this.isLoad = !this.isLoad
                })
            },
            submit() {
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad

                // if (this.wx_ssl_cert[0]) {
                // 	this.$set(this.item, 'wx_ssl_cert', this.wx_ssl_cert[0].response.data.src)
                // } else {
                // 	this.$set(this.item, 'wx_ssl_cert', '')
                // }

                // if (this.wx_ssl_cert[0]) {
                // 	this.$set(this.item, 'wx_ssl_cert', this.wx_ssl_cert[0].response.data.src)
                // } else {
                // 	this.$set(this.item, 'wx_ssl_cert', '')
                // }

                this.axios.post('/store/setting/paymentEdit', this.item).then(res => {
                    this.isLoad = !this.isLoad
                    this.$message.success({
                        message: '保存成功'
                    });
                }).catch(() => {
                    this.isLoad = !this.isLoad
                })

            },
        }
    }
</script>
<style>
</style>
